import React, { useEffect } from "react";
import { StyledTable } from "../components/styleComp";
import { fetchPivotLeads } from "../../../redux/slice/leadsPivotSlice";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../context/AuthContext";
import { Table, Spin, Card, Alert } from "antd";
import { HashLoader } from "react-spinners";
const LeadsPivot = () => {
  const { authState } = useAuth();
  const dispatch = useDispatch();
  const jwtBearer = authState.token;

  useEffect(() => {
    if (jwtBearer) {
      dispatch(fetchPivotLeads({ jwtBearer }));
    }
  }, [jwtBearer, dispatch]);

  const { leadsPivotdata, isLoadingPivot, isErrorPivot } = useSelector(
    (state) => state.leadsPivotReports
  );

  // console.log("isLoadingPivot", isLoadingPivot);

  console.log("leadsPivotData--", leadsPivotdata);

  const allFieldsPivot = leadsPivotdata?.lead_pivot || {};
  const allBA = leadsPivotdata?.total_ba || {};
  const ftmData = leadsPivotdata?.ftm_data || {};
  const allBAWithLead = leadsPivotdata?.ba_with_lead || {};

  // console.log("allBAWithLead", allBAWithLead);
  // console.log("allBAWithLead", allBAWithLead);
  // console.log("ftmData", ftmData);
  // console.log("allBA", allBA);

  const filteredData = Object.entries(allFieldsPivot)
    .filter(([key, values]) => {
      const [type, category] = key.split("', '");
      return type !== "('NULL'" && category !== "'NULL'" && values !== null;
    })
    .reduce((obj, [key, values]) => {
      obj[key] = values;
      return obj;
    }, {});

  if (Object.keys(filteredData).length === 0 && !isLoadingPivot) {
    return <Alert message="No data available." type="info" />;
  }

  const pivotData = {};

  const dataCategories = ["HOT", "WARM", "COLD"];

  const supervisors = {};

  const grandTotal = {};

  Object.entries(filteredData).forEach(([key, values]) => {
    const plCategory = key.replace(/\W/g, "");

    grandTotal[plCategory] = grandTotal[plCategory] || 0;

    if (!supervisors[plCategory]) {
      supervisors[plCategory] = [];
    }

    Object.keys(values).forEach((supervisor) => {
      if (!pivotData[supervisor]) {
        pivotData[supervisor] = {};
      }

      if (!pivotData[supervisor][plCategory]) {
        pivotData[supervisor][plCategory] = {};
      }

      pivotData[supervisor][plCategory] = values[supervisor] || 0;

      supervisors[plCategory].push(supervisor);
      grandTotal[plCategory] += values[supervisor] || 0;
    });
  });

  const calculateTotalHot = (rowData) =>
    dataCategories.reduce(
      (total, category) => total + (rowData[`PL-SEC-${category}`] || 0),
      0
    );

  const calculateTotalHotUseC = (rowData) =>
    dataCategories.reduce(
      (total, category) => total + (rowData[`PL-USEC-${category}`] || 0),
      0
    );

  const tableCellStyle = {
    fontSize: "32px", // Adjust the font size as needed
  };

  const columns = [
    {
      title: <strong style={{ fontSize: "13px" }}>SUPERVISOR</strong>,
      dataIndex: "Supervisor",
      key: "Supervisor",
      className: "table-row-light",
    },
    {
      title: <strong style={{ fontSize: "13px" }}>FTD</strong>,
      children: [
        {
          title: <strong style={{ fontSize: "13px" }}>TOTAL ACTIVE BA</strong>,
          dataIndex: "totalBA",
          key: "totalBA",
          className: "increase-font-size",
        },
        {
          title: <strong style={{ fontSize: "13px" }}>BA WITH LEAD</strong>,
          dataIndex: "baWithLead",
          key: "baWithLead",
          className: "increase-font-size",
        },
        {
          title: (
            <strong style={{ fontSize: "13px" }}>TOTAL LEAD GENERATED</strong>
          ),
          dataIndex: "totalLead",
          key: "totalLead",
          className: "increase-font-size",
          // dataIndex: 'Total Lead',
          // key: 'Total Lead'
          // className: 'table-row-blue'
        },
      ],
    },
    {
      title: <strong style={{ fontSize: "13px" }}>PL-SEC</strong>,
      children: [
        ...dataCategories
          .filter((category) => category === "HOT")
          .map((category) => ({
            title: <strong style={{ fontSize: "13px" }}>{category}</strong>,
            dataIndex: `PLSEC${category}`,
            key: `PLSEC${category}`,
            // dataIndex: `PL-SEC-${category}`,
            // key: `PL-SEC-${category}`,
            className: "increase-font-size",
          })),
        {
          title: <strong style={{ fontSize: "13px" }}>TOTAL</strong>,
          dataIndex: "TotalHOTSEC",
          key: "TotalHOTSEC",
          // dataIndex: 'Total-HOT-SEC',
          // key: 'Total-HOT-SEC',
          className: "increase-font-size",
          // render: (_, record) => calculateTotalHot(record)
        },
      ],
    },
    {
      title: <strong style={{ fontSize: "13px" }}>PL-USEC</strong>,
      children: [
        ...dataCategories
          .filter((category) => category === "HOT")
          .map((category) => ({
            title: <strong style={{ fontSize: "13px" }}>{category}</strong>,
            dataIndex: `PLUSEC${category}`,
            key: `PLUSEC${category}`,
            // dataIndex: `PL-USEC-${category}`,
            // key: `PL-USEC-${category}`,
            className: "increase-font-size",
          })),
        {
          title: <strong style={{ fontSize: "13px" }}>TOTAL</strong>,
          dataIndex: "TotalHOTUSEC",
          key: "TotalHOTUSEC",
          // dataIndex: 'Total-HOT-USEC',
          // key: 'Total-HOT-USEC',
          className: "increase-font-size",
          // render: (_, record) => calculateTotalHotUseC(record)
        },
      ],
    },
  ];

  const tableData = Object.keys(pivotData).map((supervisor) => {
    // console.log("allBA.supervisor_manager", allBA.supervisor_manager);
    const supervisorId = Object.keys(allBA.supervisor_manager).find(
      (id) => allBA.supervisor_manager[id] === supervisor
    );
    const supervisorWithLead = Object.keys(
      allBAWithLead.supervisor_manager
    ).find((id) => allBAWithLead.supervisor_manager[id] === supervisor);

    const supervisorFTM = Object.keys(ftmData.supervisor_manager).find(
      (id) => ftmData.supervisor_manager[id] === supervisor
    );

    // console.log("supervisor with lead data: " + supervisorWithLead);
    // console.log("supervisor ID",supervisorId )
    // console.log("total ba",allBA.ba_count[supervisorId])

    const rowData = {
      Supervisor: <strong>{supervisor}</strong>,
      totalBA: supervisorId ? allBA.ba_count[supervisorId] : 0,

      baWithLead: supervisorWithLead
        ? allBAWithLead.ba_count[supervisorWithLead]
        : 0,
      totalLead: supervisorWithLead
        ? allBAWithLead.lead_count[supervisorWithLead]
        : 0,
      PLSECHOT: supervisorFTM ? ftmData.hot_sec_count[supervisorFTM] : 0,
      PLUSECHOT: supervisorFTM ? ftmData.hot_usec_count[supervisorFTM] : 0,
      TotalHOTSEC: supervisorFTM ? ftmData.total_sec_count[supervisorFTM] : 0,
      TotalHOTUSEC: supervisorFTM ? ftmData.total_usec_count[supervisorFTM] : 0,
      // ...dataCategories.reduce((acc, category) => {
      //   acc[`PL-SEC-${category}`] =
      //     pivotData[supervisor][`PLSEC${category.toLowerCase()}`] || 0
      //   acc[`PL-USEC-${category}`] =
      //     pivotData[supervisor][`PLUSEC${category.toLowerCase()}`] || 0
      //   return acc
      // }, {})
    };

    rowData["Total-HOT-SEC"] = calculateTotalHot(rowData);
    rowData["Total-HOT-USEC"] = calculateTotalHotUseC(rowData);

    return rowData;
  });

  return (
    <>
      <Card
        title={
          <span style={{ fontSize: "22px", textAlign: "center" }} centered>
            Lead Summary
          </span>
        }
      >
        {isLoadingPivot ? (
          <div className="spinner-container">
            <HashLoader color="#f57171" />
          </div>
        ) : (
          <Table
            dataSource={tableData}
            columns={columns}
            size="small"
            bordered
            pagination={false}
            style={tableCellStyle}
          />
        )}
      </Card>
    </>
  );
};

export default LeadsPivot;
